import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface QuantityDiscountEntityParams {
  product_id?: number | string;
  deal_tier_id?: number | string;
  discount_id: number | string;
}
export class QuantityDiscountEntity extends BaseEntityClass {
  product_id?: number | string;
  deal_tier_id?: number | string;
  discount_id: number | string;
  constructor(params: QuantityDiscountEntityParams) {
    super();
    this.type = "deal_tier_product";
    this.entity_version = 2;
    this.product_id = params.product_id;
    this.deal_tier_id = params.deal_tier_id;
    this.discount_id = params.discount_id;
  }
}
